const CustomHr = () => {
  return (
    <hr style={{ border: "2px solid #333", width: "5%", margin: "5px auto" }} />
  );
};
export default CustomHr;
